import React, {Component} from 'react';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import { IconeCarregar } from '../../comum/components/Icones';
import { Label } from 'reactstrap';
import { buscaFiltrarVazio } from '../../../utils/mensagens';
import { observer } from 'mobx-react';

@observer
export default class TabelaAnexosCdta extends Component {

    constructor(props) {
        super(props);
        this.controller = this.props.controller;
    }

    render() {
        if(this.controller.carregandoAnexosGerencia) {
            return <IconeCarregar tamanho="2x" />
        } else if(this.controller.anexosGerenciar.length === 0) {
            return(
                <Label>
                    {buscaFiltrarVazio}
                </Label>
            )
        } else {
            return(
                    <div>
                        <ToolkitProvider
                            keyField="AppointmentNbr"
                            data={[...this.controller.anexosGerenciar]}
                            columns={[...this.controller.colunasAnexos]}
                            search
                        >
                            {props =>
                                <div>
                                    <BootstrapTable bootstrap4
                                        striped
                                        bordered={false}
                                        noDataIndication={"Nenhum registro encontrado."}
                                        classes="tabela"
                                        //expandRow={detalhesRow}
                                        {...props.baseProps} 
                                    />
                                </div>
                            }
                        </ToolkitProvider>
                    </div>
            )
        }
    }

}


// WEBPACK FOOTER //
// ./src/modules/veiculoscdta/components/TabelaAnexosCdta.js